define([], function() {

  var removeFormErrors = function(form){
    clearTimeout(window.hideErrorsTimer);
    $('.field_with_errors p.error').remove();
    $('.field_with_errors').removeClass('field_with_errors');
  };

  var addDomain = function(form){
    form.find('.restriction .loading-wrapper').prepend('<div class="ca-loading"></div>');

    $.ajax({
      type: form.attr('method'),
      url: form.attr('action'),
      data: { domain_form: { domain: form.find('input#domain_form_domain').val() } },
      success: function(result){
        removeFormErrors(form);

        if(result.domain_html){
          form.find('.allowed-domains').append(result.domain_html);
          form.find('input#domain_form_domain').val('');
        } else {
          $.each(result.errors, function(key, errors){
            var form_group = form.find('#domain_form_' + key).parent();
            form_group.addClass('field_with_errors');
            form_group.append('<p class="error">'+errors.join('; ')+'</p>');
          });

          window.hideErrorsTimer = setTimeout(function(){
            removeFormErrors(form);
          }, 6000);
        }

        form.find('.ca-loading').remove();
      }
    });
  };

  var deleteDomain = function(link){
    var url = link.attr('href');
    var link_parent = link.parents('.domain-item');
    var domain = link_parent.find('.hidden-domain-input').val();
    var form = link_parent.parents('form');

    if(url && domain){
      form.find('.restriction .loading-wrapper').prepend('<div class="ca-loading"></div>');

      $.ajax({
        type: 'PUT',
        url: url,
        data: { domain_form: { domain: domain } },
        success: function(result){
          if(result.status == 'ok'){
            link_parent.remove();
          }

          form.find('.ca-loading').remove();
        }
      });
    }
  };

  var inviteMember = function(form){
    form.find('.loading-wrapper').prepend('<div class="ca-loading"></div>');

    $.ajax({
      type: form.attr('method'),
      url: form.attr('action'),
      data: form.serialize(),
      success: function(result){
        removeFormErrors(form);

        if(result.member_html){
          form.find('table.table.university-members tbody').append(result.member_html);
          form.find('input#invite_email').val('');
        } else {
          $.each(result.errors, function(key, errors){
            var form_group = form.find('#invite_' + key).parent();
            form_group.addClass('field_with_errors');
            form_group.append('<p class="error">'+errors.join('; ')+'</p>');
          });

          window.hideErrorsTimer = setTimeout(function(){
            removeFormErrors(form);
          }, 6000);
        }

        form.find('.ca-loading').remove();
      }
    });
  };

  var addCvBook = function(form){
    form.find('.loading-wrapper').prepend('<div class="ca-loading"></div>');

    $.ajax({
      type: form.attr('method'),
      url: form.attr('action'),
      data: form.serialize(),
      success: function(result){
        removeFormErrors(form);

        if(result.cv_book_html){
          $('.cv-books-list.active-cv-books').append(result.cv_book_html);
          form.find('input#cv_book_name').val('');
          form.parents('.modal').modal('hide');
        } else {
          $.each(result.errors, function(key, errors){
            var form_group = form.find('#cv_book_' + key).parent();
            form_group.addClass('field_with_errors');
            form_group.append('<p class="error">'+errors.join('; ')+'</p>');
          });

          window.hideErrorsTimer = setTimeout(function(){
            removeFormErrors(form);
          }, 6000);
        }

        form.find('.ca-loading').remove();
      }
    });
  };

  var filterResources = function(){
    var el_filter = $('.resource-filter');
    var url = el_filter.attr('data-url');
    var tags = [];

    el_filter.find('#tags .resource-filter-input:checked').each(function(){
      tags.push($(this).val());
    });

    var filter_params = { tags: tags };

    $.ajax({
      type: 'GET',
      url: url,
      data: { resource_filter: filter_params },
      success: function(result){
        if(result.resources_html){
          $('.resources-list .resources-wrap').html(result.resources_html);
        }
      }
    });
  };

  var getResource = function(e){
    var link = $(e.currentTarget);
    var message = link.attr('data-accessMsg');

    if(message){
      e.preventDefault();
      e.stopPropagation();

      showResourceMessage(link.parents('.student-resource'), message);
    }
  };

  var showResourceMessage = function(resource_wrapper, message){
    clearTimeout(window.hideErrorsTimer);
    $('.resource-message').remove();
    resource_wrapper.append('<div class="resource-message">'+message+'</div>');

    window.hideErrorsTimer = setTimeout(function(){
      $('.resource-message').remove();
    }, 6000);
  };

  return {
    addDomain: addDomain,
    deleteDomain: deleteDomain,
    inviteMember: inviteMember,
    addCvBook: addCvBook,
    filterResources: filterResources,
    getResource: getResource
  };
});
